import * as restApi from "./restApi";
import getCacheBuster from "@/util/getCacheBuster";

const collectionUrl = "api/manufacturer";

// export const existsRecord = restApi.existsRecord.bind(null, collectionUrl);
// export const fetchRecord = restApi.fetchRecord.bind(null, collectionUrl);
export const fetchRecords = restApi.fetchRecords.bind(null, { getCacheBuster }, collectionUrl);
